var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.02,
    height: 20.02
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x_svg__cls-1",
    d: "m20.02 16.84-6.93-6.85 6.84-6.91L16.84 0 9.99 6.94 3.06.1 0 3.15l6.94 6.88L.1 16.97l3.05 3.05 6.88-6.94 6.91 6.85 3.08-3.09z",
    "data-name": "Layer 1"
  }))));
};

export { SvgX as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMC4wMiIgaGVpZ2h0PSIyMC4wMiIgdmlld0JveD0iMCAwIDIwLjAyIDIwLjAyIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgPCEtLSAuY2xzLTEgewogICAgICAgIGZpbGw6ICMwMTAxMDE7CiAgICAgIH0gLS0+CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8dGl0bGU+eC1tYXJrLTE4PC90aXRsZT4KICA8ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj4KICAgIDxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+CiAgICAgIDxwb2x5Z29uIGlkPSJ4LW1hcmstMSIgY2xhc3M9ImNscy0xIiBwb2ludHM9IjIwLjAyIDE2Ljg0IDEzLjA5IDkuOTkgMTkuOTMgMy4wOCAxNi44NCAwIDkuOTkgNi45NCAzLjA2IDAuMSAwIDMuMTUgNi45NCAxMC4wMyAwLjEgMTYuOTcgMy4xNSAyMC4wMiAxMC4wMyAxMy4wOCAxNi45NCAxOS45MyAyMC4wMiAxNi44NCIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";